module.exports = __webpack_public_path__ + "img/visa_logo.e0ebaf2c.jpg";